<template>
  <div class="portfolio-page">
    <h1>My Portfolio</h1>
          <!-- 主体内容 -->
          <main>
        <GraphicDesign :info="GraphicDesign" />
        <PortfolioIllustration :skills="PortfolioIllustration" />
        <WebDesign :experience="WebDesign" />
        <PortfolioInformation :projects="PortfolioInformation" />
        <VideoEditing :education="VideoEditing" />
        <SQLDatabase :education="SQLDatabase" />
        
        <PortfolioSection :portfolio="portfolio" />
      </main>
  </div>
  </template>
  
  <script>
    import $ from 'jquery';
  window.$ = window.jQuery = $;  
  
  import '@/assets/css/style.css';
  import '@/assets/js/javascript.js';
  import resumeData from '@/data/resumeData.js';
  
  import GraphicDesign from '@/components/portfolio/GraphicDesign.vue';
  import PortfolioIllustration from '@/components/portfolio/PortfolioIllustration.vue';
  import WebDesign from '@/components/portfolio/WebDesign.vue';
  import PortfolioInformation from '@/components/portfolio/PortfolioInformation.vue';
  import VideoEditing from '@/components/portfolio/VideoEditing.vue';
  import SQLDatabase from '@/components/portfolio/SQLDatabase.vue';
  import PortfolioSection from '@/components/common/PortfolioSection.vue';
  
  export default {
    name: 'PortfolioPage',
    components: {
      PortfolioSection,
      GraphicDesign,
      PortfolioIllustration,
      WebDesign,
      PortfolioInformation,
      VideoEditing,
      SQLDatabase
    },
    data() {
      return {
        ...resumeData, 
      };
    },
  };
  </script>
  
  <style scoped>
  </style>
  